module.exports = __webpack_public_path__ + "img/eleiko-bg-mobile.0a8d12f8.png";